import { useQuery } from '@tanstack/react-query'
import { crudDispositivosApi } from '../actions/dispositivosApi';
import { crudUsersApi } from '../actions/usersApi';
import { useAppStore } from '../store/appStore.tsx';
import { crudConfigApi } from '../actions/configApi.jsx';

/*  
 *  Para hacer las consultas al servidor se debe añadir a "body" el token del usuario logueado. 
 *  El objeto "body" debería tener las siguientes variables:
 *      - comando:  Obligatorio, es el comando que se ejecutra en el servidor
 *      - data:     Opcional, son los datos a utilizarse para cualquier modificación a la base de datos
 *  A estos comandos se añade la siguiente variable:
 *      - token:    Obligatorio, es el token que identifica al usuario actualmente logueado
 */

export function useUsersQuery(body) {
    //Se recupera el usuario actualmente logueado desde appStore creado con Zustand y se lo añade al objeto "body"
    const currentUser = useAppStore(appStore => appStore.currentUser);
    body = { ...body, token: currentUser?.token };
    
    //Con el objeto "body" completo, se hace la consulta al servidor mediante el api respectivo
    return useQuery({
        queryKey: ['users', body],
        queryFn: async () => crudUsersApi(body),
    })
}

export function useDevicesQuery(body) {
    //Se recupera el usuario actualmente logueado desde appStore creado con Zustand y se lo añade al objeto "body"
    const currentUser = useAppStore(appStore => appStore.currentUser);
    body = { ...body, token: currentUser?.token };
    
    //Con el objeto "body" completo, se hace la consulta al servidor mediante el api respectivo
    return useQuery({
        queryKey: ['dispositivos', body],
        queryFn: async () => crudDispositivosApi(body),
    })
}

export function useZonasQuery(body) {
    //Se recupera el usuario actualmente logueado desde appStore creado con Zustand y se lo añade al objeto "body"
    const currentUser = useAppStore(appStore => appStore.currentUser);
    body = { ...body, token: currentUser?.token };
    
    //Con el objeto "body" completo, se hace la consulta al servidor mediante el api respectivo
    return useQuery({
        queryKey: ['zonas', body],
        queryFn: async () => crudConfigApi(body),
    })
}

